import { Component, OnInit, OnDestroy, ChangeDetectorRef, Optional, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, NgControl, AbstractControl, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription, Subject } from 'rxjs';
import { VocabularyService } from "../services/VocabularyService";
import * as vocabularyActions from '../store/actions';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../vocabulary.module.config';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { ActionBase } from '../../core/store/action/ActionBase';
import { AddCodeSystemModel } from '../models/AddCodeSystemModel';
import { LookupModel } from '../../common/models/LookupModel';
import { Observable } from 'rxjs/Observable';
import { FocusMonitor } from '@angular/cdk/a11y';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { AddValueSetModel } from '../models/AddValueSetModel';
import { CodeSystemVersionDashboardModel } from '../models/CodeSystemVersionDashboardModel';


@Component({
  selector: 'brd-add-value-set-dialog',
  templateUrl: './add-value-set-dialog.component.html',
  styleUrls: ['./add-value-set-dialog.component.scss']
})

export class AddValueSetDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  eventUnsubscribe: Subscription;
  errors$: Observable<string[]>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  addActionIdentifier: string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;


  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<AddValueSetModel>,
    private formBuilder: FormBuilder,
    private router: Router,
    private actions$: Actions,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.addForm = formBuilder.group({
      name: ['', Validators.required],
      groupName: ['', Validators.required]
    });
  }


  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.addSuccessType<AddValueSetModel>(ModuleConfiguration.moduleName, AddValueSetModel))
      .subscribe((a: actions.AddSuccessAction<AddValueSetModel>) => {
        this.store.dispatch(new vocabularyActions.GetValueSetListAction(ModuleConfiguration.moduleName, CodeSystemVersionDashboardModel, { key: this.data.codeSystemVersionKey, searchTerm: this.data.search, hideEmpty: this.data.hideEmpty }));
        this.close();
      });
    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.addActionIdentifier && a.payload.action.identifier === this.addActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        this.addActionIdentifier = undefined;
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }

      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
    this.destroyed$.next(true);
  }

  add() {
    var model = this.data;
    model.name = this.addForm.value.name;
    model.codeSystemVersionKey = this.data.codeSystemVersionKey;
    model.groupName = this.addForm.value.groupName;
    var addAction = new actions.AddAction(ModuleConfiguration.moduleName, AddValueSetModel, { model: model });
    this.addActionIdentifier = addAction.identifier;
    this.store.dispatch(new actions.AddAction(ModuleConfiguration.moduleName, AddValueSetModel, { model: model }));
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/add-value-set-dialog.component.ts